var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"text-xs text-center mb-3",class:{ 'fixed-bottom': _vm.fixed }},[_c('span',[_vm._v(" (C) Mobilenik 2020. The usage of this site is reserved for Mobilenik customers. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }